// extracted by mini-css-extract-plugin
var _1 = "_yP4TPWsxvuIXZpKVHRK";
var _2 = "VumeVvfFXrigwmWnIJRQ";
export { _1 as "inner", _2 as "root" }
